import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

const initialState = function () {
  return {
    fullScreen: false,
  }
}

export const state = initialState

export const mutations = {
  SET: function (state) {
    Vue.set(state, "fullScreen", true)
  },
  ...resetMixin.mutations,
}

export const actions = {
  SET: function ({ commit }) {
    commit("SET")
  },
  RESET: async function ({ commit }) {
    commit("RESET", initialState())
  },
}
